class UserProgram {

    static getUserProgramUsingByStartYearAndProgramId(startYear, program, then) {

        return axios.get("ajax/userprogram", {
            params: {
                year: startYear,
                programId: program
            }
        }).then(({ data }) => then(data));
    }

    static fetchData(then) {

        return axios.get("ajax/fetchdata")
            .then(({
                data
            }) => then(data));

    }

    static getAllProgramsAnCodes(year, then) {
        return axios.get("ajax/programsAndCodes", {
            params: {
                year: year
            }
        }).then(({ data }) => then(data));
    }

    static validateColumn(selectedProgram, userProgramYear, year, then) {
        return axios.post("ajax/userProgram/validateColumn", {
            params: {
                year: year,
                selectedProgramId: selectedProgram,
                userProgramYear: userProgramYear
            }
        }).then(({ data }) => then(data));
    }

    static validateColumnSanctions(userProgramId, sanctionCeckedYear, selectedIds, then) {
        return axios.post("ajax/userProgram/validateYearlySanctions", {
            params: {
                userProgramId: userProgramId,
                sanctionCeckedYear: sanctionCeckedYear,
                selectedIds: selectedIds
            }
        }).then(({ data }) => then(data));
    }

    static checkUserProgramSanctions(userProgramId, selectedIds, then) {
        return axios.post("ajax/userProgram/checkUserProgramSanctions", {
            params: {
                userProgramId: userProgramId,
                selectedIds: selectedIds
            }
        }).then(({ data }) => then(data));
    }

}

export default UserProgram;



// WEBPACK FOOTER //
// ./resources/assets/js/moldels/UserProgram.js